// helpers
import {formatCurrency} from '../../../../helpers';

// types
import {TFunction} from 'i18next';
import {Loan} from '../../../../services/ApiService/types';

/**
 * Get the summary fields for loan details
 * @param loanSummary
 * @param t
 */
export const getSummaryFields = (loanSummary: Loan, t: TFunction) => {
  const fields = [
    {
      label: t('global_status'),
      content: loanSummary.status,
    },
    {
      label: t('loan_loanAmount'),
      content: formatCurrency(loanSummary.amount),
    },
    {
      label: t('global_currentBalance'),
      content: formatCurrency(loanSummary.currentBalance),
    },
    {
      label: t('global_paymentFrequency'),
      content: loanSummary.paymentFrequency,
    },
    {
      label: t('global_numberOfPayments'),
      content: loanSummary.numberOfPayments.toString(),
    },
    {
      label: t('global_totalOwing'),
      content: formatCurrency(loanSummary.totalOwing),
    },
    {
      label: t('global_creationDate'),
      content: loanSummary.startDate,
    },
  ];
  return fields;
};
